
import { computed, defineComponent, onMounted } from "vue";
import { RouterLink, useRoute } from "vue-router";

import EmptyState from "../components/empty-state.vue";
import { Icon } from "../components/icons";
import StatusBadge from "../components/status-badge.vue";
import {
  categoryName,
  getListingById,
  resolveCategory,
  subCategoryName,
} from "../data/query";
import { site } from "../data/site";
import { displayViews, rememberVisit } from "../store/preferences";
import common from "../styles/common.module.less";
import style from "./style.module.less";

export default defineComponent({
  name: "XiyouDetail",
  setup() {
    const route = useRoute();
    const id = computed(() => parseInt(String(route.params.id), 10));
    const listing = computed(() => getListingById(id.value));

    // 本地浏览记录与浏览量累加（无接口调用）
    onMounted(() => {
      const item = listing.value;
      if (item) rememberVisit(item.id);
    });

    return () => {
      const item = listing.value;
      if (!item) {
        return (
          <div class={common.shell}>
            <EmptyState
              title="信息不存在或已下线"
              desc="该信息可能已被删除，请返回信息门户浏览其它内容。"
              icon="alert"
            >
              <RouterLink
                class={[common.btn, common.btnPrimary]}
                to={{ name: "XiyouPortal" }}
              >
                返回信息门户
              </RouterLink>
            </EmptyState>
          </div>
        );
      }

      const category = resolveCategory(item.category);
      const sub = subCategoryName(item.category, item.subCategory);
      const sourceText =
        item.publisherType === "merchant" ? "商家发布" : "个人发布";

      return (
        <div class={common.shell}>
          <nav class={common.crumbs}>
            <RouterLink class={common.crumbLink} to={{ name: "XiyouHome" }}>
              首页
            </RouterLink>
            <span class={common.crumbSep}>/</span>
            <RouterLink class={common.crumbLink} to={{ name: "XiyouPortal" }}>
              信息门户
            </RouterLink>
            {category ? (
              <span class={style.crumbGroup}>
                <span class={common.crumbSep}>/</span>
                <RouterLink
                  class={common.crumbLink}
                  to={{
                    name: "XiyouPortal",
                    query: { category: category.slug },
                  }}
                >
                  {category.name}
                </RouterLink>
              </span>
            ) : null}
            <span class={common.crumbSep}>/</span>
            <span class={common.crumbCurrent}>信息详情</span>
          </nav>

          <div class={style.head}>
            <div class={common.badgeRow}>
              {item.top ? <StatusBadge text="置顶" tone="top" /> : null}
              {item.recommend ? (
                <StatusBadge text="推荐" tone="recommend" />
              ) : null}
              <StatusBadge text={categoryName(item.category)} tone="plain" />
              {sub ? <StatusBadge text={sub} tone="plain" /> : null}
              <StatusBadge text={sourceText} tone={item.publisherType} />
            </div>
            <h1 class={style.title}>{item.title}</h1>
            <div class={style.meta}>
              <span class={common.cardMetaItem}>
                <Icon name="clock" />
                {item.publishedAt}
              </span>
              <span class={common.cardMetaItem}>
                <Icon name="eye" />
                {displayViews(item.views, item.id)} 次浏览
              </span>
              <span class={common.cardMetaItem}>
                <Icon name="doc" />
                信息编号 {item.id}
              </span>
            </div>
          </div>

          <div class={style.layout}>
            <div class={style.main}>
              <section class={style.panel}>
                <div class={style.priceBox}>
                  <span class={style.priceLabel}>价格</span>
                  <span class={style.price}>{item.price}</span>
                </div>
                <div class={style.panelHead}>信息详情</div>
                <div class={common.prose}>
                  {item.content.map((text) => (
                    <p key={text}>{text}</p>
                  ))}
                </div>
              </section>
              <section class={style.tip}>
                <Icon name="alert" />
                {site.safetyNote}
              </section>
            </div>

            <aside class={style.aside}>
              <div class={style.panel}>
                <div class={style.panelHead}>发布人信息</div>
                <div class={style.infoRow}>
                  <span class={style.infoLabel}>发布人</span>
                  <span>{item.publisherName}</span>
                </div>
                {item.companyName ? (
                  <div class={style.infoRow}>
                    <span class={style.infoLabel}>主体名称</span>
                    <span>{item.companyName}</span>
                  </div>
                ) : null}
                <div class={style.infoRow}>
                  <span class={style.infoLabel}>发布来源</span>
                  <span>{sourceText}</span>
                </div>
                <div class={style.infoRow}>
                  <span class={style.infoLabel}>联系电话</span>
                  <span class={style.phone}>
                    <Icon name="phone" />
                    {item.contactPhone}
                  </span>
                </div>
                <p class={style.legal}>{site.legalNote}</p>
              </div>
              <RouterLink
                class={[common.btn, common.btnPrimary, style.asideBtn]}
                to={{
                  name: "XiyouPortal",
                  query: { category: item.category },
                }}
              >
                查看更多同类信息
              </RouterLink>
            </aside>
          </div>
        </div>
      );
    };
  },
});
